export const state = {
  patientSettings: {
    firstName: "",
    lastName: "",
    birthDate: "",
    state: "",
    address: "",
    email: "",
    phoneNumber: "",
    generalInformation: {
      height: "",
      weight: "",
      isSmoking: false,
    },
    medicalInformation: {
      pmh: [],
      medications: [],
      allergies: [],
    },
  },
  practitionerSettings: {
    firstName: "",
    lastName: "",
    email: "",
    timeZone: "",
    locale: "",
  },
  ownerSettings: {
    firstName: "",
    lastName: "",
    email: "",
    timeZone: "",
    locale: "",
  },
  registrarSettings: {
    firstName: "",
    lastName: "",
    email: "",
    timeZone: "",
    locale: "",
  },
  avatar: null,
};
